import React from 'react';
import BlogHero from '../blocks/blog/hero';
import BlogHeroDetailed from '../blocks/blog/hero-detailed';
import BlogPost from '../blocks/blog/post';
import BlogPostList from '../blocks/blog/list';
import Disqus from '../blocks/disqus';
import FreeTrial from '../blocks/free-trial/free_trial';

const BlogProxy = ({
  block,
  featured,
  post,
  tags,
  posts,
  location,
  pagePrefix,
  parentPage,
}: BlogProxyProps) => {
  switch (block._template) {
    case 'block__blog_hero':
      if (featured) {
        // blog index pages
        return (
          <BlogHero
            block={block}
            data={featured}
            parentPage={parentPage}
          />
        );
      } else {
        // blog post pages
        return (
          <BlogHeroDetailed
            block={block}
            data={post}
            parentPage={parentPage}
          />
        );
      }
    case 'block__blog_post':
      return (
        <BlogPost
          block={block}
          data={post}
        />
      );
    case 'block__blog_post_list':
      return (
        <BlogPostList
          block={block}
          urlParams={location.search}
          allTags={tags}
          posts={posts}
          pathname={location.pathname}
          pagePrefix={pagePrefix}
        />
      );
    case 'block__disqus':
      return <Disqus block={block} />;
    case 'block__start_free_trial':
      let textPositionClass = 'pos-center';
      if (block.text_position === 'Left') {
        textPositionClass = 'pos-left';
      } else if (block.text_position === 'Right') {
        textPositionClass = 'pos-right';
      }
      return (
        <FreeTrial
          block={{
            ...block,
            text_position_class: textPositionClass,
          }}
        />
      );
    default:
      return <p>Missing block.</p>;
  }
};

export default BlogProxy;
